import React from "react";

export const ACCREDITATIONS = [
  {
    key: "esh",
    body: "European Society of Hypertension",
    designation: "Accredited Specialist Centre",
    logo: "/accreditations/esh.png",
    url: "https://www.eshonline.org/communities/excellence-centres/",
  },
  {
    key: "eacvi",
    body: "European Association of Cardiovascular Imaging",
    designation: "Accredited Echocardiography Centre",
    logo: "/accreditations/eacvi.png",
    url: "https://www.escardio.org/Sub-specialty-communities/European-Association-of-Cardiovascular-Imaging-(EACVI)",
  },
];

export default function Accreditations({ variant = "full", className = "" }) {
  if (variant === "compact") {
    return (
      <div className={`flex flex-wrap gap-3 ${className}`} data-testid="accreditations-compact">
        {ACCREDITATIONS.map(({ key, body, designation, logo }) => (
          <div key={key} className="flex items-center gap-3 px-4 py-3 bg-white border border-bronze-light/40 rounded-md text-left">
            <img src={logo} alt={`${body} logo`} className="h-10 w-auto object-contain shrink-0" loading="lazy" />
            <div className="leading-tight">
              <div className="text-[10px] uppercase tracking-[0.2em] text-ink-muted">{body}</div>
              <div className="text-xs font-medium text-ink mt-0.5">{designation}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className={`grid sm:grid-cols-2 gap-5 ${className}`} data-testid="accreditations-full">
      {ACCREDITATIONS.map(({ key, body, designation, logo, url }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          data-testid={`accreditation-${key}`}
          className="group flex items-start gap-5 p-7 bg-white border border-bronze-light/40 rounded-md hover:-translate-y-0.5 hover:shadow-md transition-all"
        >
          <div className="w-20 h-20 shrink-0 rounded-md bg-cream-50 border border-bronze-light/30 flex items-center justify-center p-2.5">
            <img src={logo} alt={`${body} logo`} className="max-h-full max-w-full object-contain" loading="lazy" />
          </div>
          <div>
            <div className="eyebrow">{body}</div>
            <div className="font-serif text-xl mt-2 text-ink leading-snug">{designation}</div>
            <div className="mt-3 text-xs text-bronze-dark group-hover:underline">Learn more →</div>
          </div>
        </a>
      ))}
    </div>
  );
}
